<template>
  <aside
    id="app-drawer"
    :class="['sidebar', { 'is-open': open }]"
    role="navigation"
    aria-label="Hauptnavigation"
  >
    <h1 class="brand">
      Anwesenheitsliste
    </h1>
    <nav>
      <RouterLink
        to="/dashboard"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-home nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Dashboard</span>
      </RouterLink>

      <RouterLink
        v-if="isParent"
        to="/notifications"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-users nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Meldungen</span>
        <i
          v-if="notificationsHasUnread"
          class="pi pi-envelope nav-icon"
          aria-hidden="true"
          title="Ungelesene Nachrichten"
          style="font-size:16px;color:var(--info);margin-left:6px;"
        />
      </RouterLink>

      <RouterLink
        v-if="isParent"
        to="/teacher-infos"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-info-circle nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Hinweise</span>
      </RouterLink>

      <RouterLink
        v-if="isParent"
        to="/parent/absences"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-times-circle nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Fehlzeiten</span>
      </RouterLink>
      <!-- Admin-only -->
      <RouterLink
        v-if="isAdmin"
        to="/school-years"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-calendar nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Schuljahre</span>
      </RouterLink>

      <!-- Angebote-Bereich -->
      <div
        v-if="isAdmin || isTeacher"
        class="nav-section"
      >
        <div
          class="nav-section-header"
          style="display:flex;align-items:center;gap:8px;margin-bottom:4px;padding:6px 10px;"
        >
          <i
            class="pi pi-users nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span class="muted section-label">Schüler</span>
        </div>
        <RouterLink
          to="/students"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Übersicht</span>
        </RouterLink>
        <RouterLink
          to="/notifications"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Meldungen</span>
        </RouterLink>
        <RouterLink
          to="/notifications/messages"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Nachrichten</span>
          <i
            v-if="notificationsHasUnread"
            class="pi pi-envelope nav-icon"
            aria-hidden="true"
            title="Ungelesene Nachrichten"
            style="font-size:14px;color:var(--info);margin-left:6px;"
          />
        </RouterLink>
        <RouterLink
          v-if="isAdmin || isTeacher"
          to="/follow-day"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Folgetag</span>
        </RouterLink>
        <RouterLink
          to="/teacher-infos"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Hinweise</span>
        </RouterLink>
        <RouterLink
          v-if="isAdmin"
          to="/admin/school-enrollment"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          <span>Anmeldungen</span>
        </RouterLink>

        <RouterLink
          to="/groups"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
        >
          <i
            class="pi pi-sitemap nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Gruppen</span>
        </RouterLink>

        <div
          class="nav-section-header"
          style="display:flex;align-items:center;gap:8px;margin-bottom:4px;padding:6px 10px;"
        >
          <i
            class="pi pi-clock nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span class="muted section-label">Angebote</span>
        </div>
        <!-- Sublinks ohne Icons, eingerückt -->
        <RouterLink
          v-if="isTeacher"
          to="/admin/offers"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          Übersicht
        </RouterLink>
        <RouterLink
          v-if="isAdmin"
          to="/admin/offers"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          Übersicht
        </RouterLink>
        <RouterLink
          v-if="isAdmin || isTeacher"
          to="/auto-offers"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          Automatik
        </RouterLink>
        <RouterLink
          to="/offers-day-view"
          class="nav-sublink"
          style="display:block;padding:6px 10px 6px 50px;border-radius:8px;transition:background-color 160ms;"
        >
          Tagesplan
        </RouterLink>
        <!-- Nutzerverwaltung: Admin & Lehrer (Lehrer read-only in View) -->
        <RouterLink
          to="/users"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
        >
          <i
            class="pi pi-user nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Benutzer</span>
        </RouterLink>
        <RouterLink
          v-if="isAdmin || isTeacher"
          to="/outbox"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
        >
          <i
            class="pi pi-envelope nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Postausgang</span>
        </RouterLink>
        <RouterLink
          v-if="isAdmin || isTeacher"
          to="/analytics"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
        >
          <i
            class="pi pi-chart-bar nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Auswertung</span>
        </RouterLink>
        <RouterLink
          v-if="isAdmin"
          to="/admin/change-logs"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
        >
          <i
            class="pi pi-book nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Logbuch</span>
        </RouterLink>
        <RouterLink
          v-if="isAdmin || isTeacher"
          to="/tickets"
          class="nav-item"
          style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;margin-top: 15px;"
        >
          <i
            class="pi pi-ticket nav-icon"
            aria-hidden="true"
            style="font-size:18px;color:var(--muted);"
          />
          <span>Tickets</span>
          <strong
            v-if="unreadCount > 0"
            class="nav-count text-small"
          >({{ unreadCount }})</strong>
        </RouterLink>
      </div>
      <RouterLink
        to="/documentation"
        class="nav-item"
        style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;"
      >
        <i
          class="pi pi-book nav-icon"
          aria-hidden="true"
          style="font-size:18px;color:var(--muted);"
        />
        <span>Dokumentation</span>
      </RouterLink>

      <!-- Profil-Link entfernt -->
    </nav>
    <div class="sidebar-footer muted">
      <span
        v-if="isStage"
        class="env-badge"
        title="Stage-Umgebung"
      >STAGE</span>
      v{{ version }}
    </div>
  </aside>
</template>

<script>
import {useTicketsStore} from '@/stores/tickets';
import api from '@/services/api';
import {fetchNotificationsUnreadMap} from '@/api/notifications';

export default {
  name: 'SidebarNav',
  props: {
    open: {type: Boolean, default: false}
  },
  data() {
    return {
      appEnv: null,
      version: process.env.VUE_APP_VERSION || 'dev',
      user: JSON.parse(localStorage.getItem('user') || 'null'),
      notificationsHasUnread: false,
      notificationsUnreadTimer: null,
    };
  },
  computed: {
    roleId() {
      return this.user?.roleId;
    },
    isAdmin() {
      return this.roleId === 1;
    },
    isTeacher() {
      return this.roleId === 2;
    },
    isParent() {
      return this.roleId === 3;
    },
    // Stage-Flag aus Backend-Response ableiten
    isStage() {
      const v = (this.appEnv || '').toString().toLowerCase().trim();
      return v === 'stage';
    },
    unreadCount() {
      // Reaktiv an den Tickets-Store binden
      return useTicketsStore().unreadCount || 0;
    },
  },
  async mounted() {
    // Nur nach gültigem Login (Token vorhanden) Abfragen durchführen
    try {
      const token = (typeof localStorage !== 'undefined') ? (localStorage.getItem('token') || '') : '';
      if (token && token.trim()) {
        // Environment (APP_ENV) vom Backend laden, um Stage-Badge zu steuern
        try {
          const {data} = await api.get('/env');
          this.appEnv = data && data.appEnv ? String(data.appEnv) : null;
        } catch (e) {
          // still
        }

        // Tickets nur laden, wenn sichtbar (Admin/Lehrer)
        if (this.isAdmin || this.isTeacher) {
          await useTicketsStore().fetchUnreadCount({force: true});
        }

        // Meldungen: Unread-Status für SideNav laden (Backend zählt bereits ohne eigene sender_user_id)
        await this.refreshNotificationsUnread();
        this.notificationsUnreadTimer = setInterval(() => {
          this.refreshNotificationsUnread();
        }, 60000);
      }
    } catch (e) {
      // still
    }
  },
  beforeUnmount() {
    if (this.notificationsUnreadTimer) {
      clearInterval(this.notificationsUnreadTimer);
      this.notificationsUnreadTimer = null;
    }
  },
  methods: {
    async refreshNotificationsUnread() {
      try {
        const map = await fetchNotificationsUnreadMap();
        const vals = map && typeof map === 'object' ? Object.values(map) : [];
        const has = (vals || []).some(v => {
          const n = Number(v);
          return Number.isFinite(n) && n > 0;
        });
        this.notificationsHasUnread = Boolean(has);
      } catch (e) {
        this.notificationsHasUnread = false;
      }
    },
  },
};
</script>

<style scoped>
/* Einheitliche Hover-Zustände für Hauptlinks und Sublinks (dezent) */
.nav-item,
.nav-sublink {
  text-decoration: none;
  color: inherit;
}

.nav-item:hover,
.nav-sublink:hover {
  /* Fallback-Farbe (dezent) + moderner color-mix */
  background-color: rgba(79, 70, 229, 0.08);
  background: color-mix(in srgb, var(--primary) 10%, transparent);
}

/* Aktive/Focus-States subtil verstärken */
.nav-item:focus-visible,
.nav-sublink:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 3px var(--focus);
}

/* Fette Zähler-Anzeige hinter "Tickets" */
.nav-count {
  font-weight: 700;
  margin-left: 6px;
  color: var(--text);
}

/* Footer-Zeile im Sidebar (Version + optionaler Badge) */
.sidebar-footer {
  padding: 10px;
  border-top: 1px solid var(--border);
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* Stage-Badge: kompakt, dezent, Token-basiert */
.env-badge {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--warn) 10%, transparent);
  border: 1px solid var(--border-strong);
  color: var(--warn);
  width: max-content;
}

/* Mobile Drawer: Sidebar überlagert Inhalt und schiebt ein */
@media (max-width: 1366px) {
  .sidebar {
    position: fixed;
    inset: 0 auto 0 0; /* top:0; right:auto; bottom:0; left:0 */
    width: 280px;
    max-width: 86vw;
    height: 100vh;
    transform: translateX(-100%);
    transition: transform 200ms cubic-bezier(0.2, 0, 0, 1);
    z-index: 1000;
    background: var(--surface);
    border-right: 1px solid var(--border);
    border-radius: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.22);
  }

  .sidebar.is-open {
    transform: translateX(0);
  }
}
</style>
